// Centralized UI theme tokens using Tailwind utility class strings
// Usage: import { ui } from '../config/theme';

export const ui = {
  // Layout
  page: 'flex flex-col min-h-screen bg-gradient-to-br from-slate-50 to-blue-50',
  container: 'w-full max-w-[1400px] mx-auto px-4 py-8 sm:px-6 lg:px-8',

  // Surfaces
  card: 'bg-white rounded-2xl shadow-lg p-8 border border-slate-100',
  sectionCard: 'bg-white rounded-xl shadow-lg p-6 border border-slate-100',

  // Typography
  heading: 'text-3xl font-bold text-slate-800 tracking-tight',
  subheading: 'text-lg font-medium text-gray-900',
  muted: 'text-slate-600',
  subtle: 'text-slate-500',

  // Buttons
  buttonPrimary: 'inline-flex items-center gap-2 bg-gradient-to-r from-blue-500 to-blue-700 text-white px-6 py-2.5 rounded-xl shadow-md hover:shadow-lg transition-all duration-300',
  buttonPrimarySm: 'inline-flex items-center gap-2 bg-gradient-to-r from-blue-500 to-blue-700 text-white px-5 py-2 rounded-lg shadow hover:shadow-md transition-all duration-300',
  buttonLink: 'inline-flex items-center text-blue-600 font-medium hover:text-blue-700 transition-all',

  // Inputs
  input: 'w-full pl-10 pr-4 py-2.5 border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-sm',
  select: 'w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-sm',

  // Badges
  pillPrimary: 'px-3 py-1 bg-blue-100 text-blue-800 text-sm rounded-full',
  pillSuccess: 'px-3 py-1 bg-green-100 text-green-800 text-sm rounded-full',
  pillDanger: 'px-3 py-1 bg-red-100 text-red-800 text-sm rounded-full',

  // Utility sections
  section: 'mb-8',
  sectionTitleRow: 'flex items-center gap-2 text-gray-900 font-medium mb-4',
};
